import React, { useState } from 'react';
import { List, ListItem } from '@icarros/ids-react';
import { useHistory, useLocation } from 'react-router';
import { primaryRoutes, secondaryRoutes } from './routes';

import { IconWrapper, ListItemModifier, SidebarWrapper } from './style';

import { useKeycloak } from '@react-keycloak/web';

export function Sidebar(): JSX.Element {
  const { keycloak } = useKeycloak();
  const [isHovering, setIsHovering] = useState(false);
  const location = useLocation();
  const history = useHistory();

  const onLogoutClick = () => {
    if (process.env.NODE_ENV !== 'development') {
      window.location.href = '/logout';
    } else {
      keycloak.logout();
    }
  };

  return (
    <SidebarWrapper
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      <List>
        {primaryRoutes.map(({ name, highlight, iconName, path, hoveringIconName, Icon, link }) => (
          <ListItemModifier
            highlight={highlight}
            key={name}
            active={!highlight && !!path && location.pathname.includes(path)}
            isCustom={!!Icon}
          >
            <ListItem
              label={name}
              avatarIconElement={
                Icon && (
                  <IconWrapper>
                    <Icon />
                  </IconWrapper>
                )
              }
              avatarIcon={highlight && isHovering ? hoveringIconName : iconName}
              avatarVariant="icon"
              variant="action"
              hasLine={false}
              actionOnClick={() =>
                path ? history.push(path) : window.open(link, '_blank', 'noreferrer noopener')
              }
            />
          </ListItemModifier>
        ))}
      </List>
      {keycloak.authenticated && (
        <List>
          {secondaryRoutes.map(({ name, iconName }) => (
            <ListItemModifier key={name}>
              <ListItem
                key={name}
                label={name}
                avatarIcon={iconName}
                avatarVariant="icon"
                variant="action"
                hasLine={false}
                actionOnClick={() => onLogoutClick()}
              />
            </ListItemModifier>
          ))}
        </List>
      )}
    </SidebarWrapper>
  );
}
